import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_STATUS_INITIALIZED,
  STORE_USER,
  STORE_USER_FETCH_CAMERA_RESOURCES,
} from 'constants/store'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import { Payload } from 'stores'
import {
  CameraResourcesResponse,
  CameraResourceStatus,
  ErrorStore,
} from '@types'

export type CameraResourcesState = CameraResourcesResponse

type State = GenericState<CameraResourcesState>

export const initialState: State = {
  data: {
    camera: {},
    geolocation: {},
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchCameraResources = createAsyncThunk<
  CameraResourcesState,
  Promise<CameraResourcesResponse>,
  Payload
>(STORE_USER_FETCH_CAMERA_RESOURCES, async (promise, { rejectWithValue }) => {
  try {
    const result = await promise
    let globalStatus: CameraResourceStatus = 'undefined'
    if (result.camera.status === 'undefined') {
      globalStatus = 'undefined'
    } else if (result.camera.status === 'denied') {
      globalStatus = 'denied'
    } else if (result.camera.status === 'prompt') {
      globalStatus = 'prompt'
    } else if (result.camera.status === 'granted') {
      globalStatus = 'granted'
    }
    return {
      camera: result.camera,
      geolocation: result.geolocation,
      available: globalStatus === 'granted',
      globalStatus,
    }
  } catch (e: unknown) {
    const { code, message } = e as ErrorStore
    return rejectWithValue({ code, message })
  }
})

const extraReducers: ExtraReducers = createReducers<
  CameraResourcesState,
  CameraResourcesResponse,
  Payload
>(fetchCameraResources, initialState.data)

const slice = createGenericSlice({
  name: STORE_USER,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = slice

const { clear } = actions

export { clear }

export default reducer
